export const sendNewUserRegistrationToDatalayer = (newUser) => {
    if(typeof dataLayer != 'undefined' && dataLayer && dataLayer.push) {
        dataLayer.push({ 'event': 'processed', 'category': 'Registration', 'action': `${newUser ? 'New' : 'Existing'}`, 'label': window.location.pathname});
    }
}

export const sendNewUserAdminCreatedToDatalayer = () => {
    if(typeof dataLayer != 'undefined' && dataLayer && dataLayer.push) {
        dataLayer.push({ 'event': 'processed', 'category': 'Registration', 'action': 'Admin-Created', 'label': window.location.pathname});
    }
}

export const sendUserRegistrationToDatalayer = () => {
    let urlParms = new URLSearchParams(window.location.search);
    if (urlParms.has("userType")) {
        var userType = urlParms.get("userType").toLowerCase();

        if (typeof dataLayer != 'undefined' && dataLayer && dataLayer.push) {
            dataLayer.push({ 'event': 'registration', 'userType': userType });
        }
    }
}